import * as TE from 'fp-ts/TaskEither';
import { useApprovalStatusesStore } from '@/stores/analytics/approvalStatuses';
import { filterStatus, publicFilterStatus } from '@/services/api/resources/approval';
import { analyticsFilterGet, publicAnalyticsFilterGet } from '@/services/api/resources/question';
import { useFormItemsStore } from '@/stores/analytics/formItems';

export const retrieveApprovalStatuses = (isPublic = false) => {
  const store = useApprovalStatusesStore();

  if (store.approvalStatuses.length !== 0) {
    return TE.right({ data: store.approvalStatuses });
  }

  return isPublic ? publicFilterStatus() : filterStatus();
};

export const retrieveFormItem = (id: string, reportId: number | null) => {
  const store = useFormItemsStore();

  const formItem = store.formItems.get(id);

  if (formItem) {
    return TE.right({ data: [formItem] });
  }

  return reportId
    ? publicAnalyticsFilterGet(reportId, id)
    : analyticsFilterGet(id);
};
